import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FormAutoComplete } from '../../../../components/index';
import {
  getUserPermissionsListByUserRequest,
  clearUserPermissionsListByUser,
  clearUserPermissionsList,
} from '../../../../store/modules/user-permissions/actions';
import { selectUserPermissionsListByUser } from '../../../../store/modules/user-permissions/selectors';
import { selectCurrentUser } from '../../../../store/modules/users/selectors';
import { uniqueList } from './utils';
import { Project } from '../../../../types/items';

type Props = {
  project: Project | null;
  duplicate?: boolean;
};

const OrganizationField = ({ project, duplicate = false }: Props) => {
  const dispatch = useDispatch();
  const user = useSelector(selectCurrentUser);
  const organizations = useSelector(selectUserPermissionsListByUser);
  const canEdit = project?.permissions.can_edit || false;
  const projectOrganization = (project && project.ref && project.ref.organization)
    ? [{ id: project.ref.organization.id, label: project.ref.organization.common_name }]
    : [];

  const organizationsList = (duplicate || canEdit)
    ? uniqueList(organizations.data?.items.map((item) => ({
      label: item.ref.organization.common_name,
      id: item.ref.organization.id,
    })))
    : projectOrganization;

  useEffect(() => {
    if (!organizations.data && !organizations.loading) {
      if (user.data) {
        dispatch(getUserPermissionsListByUserRequest(user.data.id));
      }
    }

    return () => {
      if (organizations.data !== null) {
        dispatch(clearUserPermissionsListByUser());
        dispatch(clearUserPermissionsList());
      }
    };
  }, [organizations, user, dispatch]);

  return (
    <FormAutoComplete
      data={organizationsList}
      disabled={duplicate ? false : !canEdit}
      label="Organization"
      name="organization_id"
    />
  );
};

export default OrganizationField;
